<template>
  <div class="container-fluid no-padding">
    <md-table-card>
      <!-- WBDataTable header -->
      <div class="custome-header">
        <div v-if="!isTitleHtml" class="title">
          <p>{{tableName}}</p>
          <i class="separator"></i>
          <span v-if="showVisibleFilteredDataextCounter" class="table-row-counter">{{paginatedDataext.length}}</span>
          <span v-if="countTitle" class="counter-title">{{countTitle}}</span>
        </div>
        <div v-else-if="isTitleHtml" v-html="htmlTitle" class="title title-html"></div>
        <div class="tools">
          <div class="quick-filter" v-if="quickFilter && quickFilter.title && quickFilter.property">
            <input id="quickFilter" v-model="quickFilter.value" @change='quickFilterChange' type="checkbox"></input>
            <label for="quickFilter">{{quickFilter.title}}</label>
          </div>
          <div class="search-container" v-if="!disableSearch">
            <md-input-container>
              <md-icon>search</md-icon>
              <md-input type="text" v-model="searchTerm"></md-input>
            </md-input-container>
          </div>
          <div v-if="hasControls && customHeaderTools" >
            <template v-for="(customHeaderTool, index) in customHeaderTools" >
              <md-menu md-align-trigger v-if="customHeaderTool.type === 'dropdown'" :class="[customHeaderTool.className?customHeaderTool.className:'']" :key="index+'dropdown'">
                <md-icon md-menu-trigger>{{ customHeaderTool.icon }}</md-icon>
                <md-menu-content>
                  <md-menu-item @click="item.handler" v-for="(item, key) in customHeaderTool.list" :key="key">{{item.name}}</md-menu-item>
                </md-menu-content>
              </md-menu>
              <md-button v-else class="md-icon-button" @click="customHeaderTool.handler" :class="[customHeaderTool.className?customHeaderTool.className:'']" :key="index+'icon-button'">
                <md-icon>{{ customHeaderTool.icon }}</md-icon>
              </md-button>
              <span class="wb-tooltip" v-if="customHeaderTool.tooltip" :key="index+'tooltip'">{{customHeaderTool.tooltip}}</span>
            </template>
          </div>
          <md-button @click="$emit('addEmit', false)" class="md-icon-button" v-if="hasControls && allowCreation">
            <md-icon>add</md-icon>
          </md-button>
          <md-button v-if="hasFilter" tabindex="-1" class="md-icon-button show-columns-icon">
            <md-icon v-on:click.native="addFilterCondition()">filter_list</md-icon>
          </md-button>
          <md-button class="md-icon-button show-columns-icon">
            <md-icon v-on:click.native="toggleColumnSettings(null)">more_vert</md-icon>
          </md-button>
          <transition name="component-fade" mode="in-out">
            <div v-if="showColumnSettings" class="select-container" @click.stop>
              <div>
                <div v-if="selectOrUnselectAllColumnsOptionVisible">
                  <div class="select-container-select-all" @click="toggleColumnSettings('show all')">Select all</div>
                </div>
                <div v-if="selectOrUnselectAllColumnsOptionVisible">
                  <div class="select-container-unselect-all" @click="toggleColumnSettings('hide all')">Unselect all</div>
                </div>
                <div v-for="column in visibleColumns" :key="column.name">
                  <md-checkbox v-model="column.visible" v-on:change="toggleColumnSettings([column.name, column.visible])">{{column.displayName}}</md-checkbox>
                </div>
              </div>
            </div>
          </transition>
          <div class="filter-container" v-if="filterBy.length > 0">
            <md-chip v-for="(filter, index) in filterBy" v-if="!filter.filterObjectSelection" md-deletable class="md-chip-filter" :key="filter.columnDisplayName" @delete="deleteFilterCondition(filter)">
              {{filter.columnDisplayName}} {{filter.filterCondition}} {{filter.filterValue}}
              <md-button v-on:click.native="editFilterCondition(filter, index)" class="md-icon-button md-chip-icon-button md-dense">
                <md-icon>edit</md-icon>
              </md-button>
            </md-chip>
            <md-chip v-for="(filter, index) in filterBy" v-if="filter.filterObjectSelection" md-deletable class="md-chip-filter" :key="filter.columnDisplayName" @delete="deleteFilterCondition(filter)">
              {{filter.columnDisplayName}} ({{filter.filterValues.length}})
              <md-button tabindex="-1" v-on:click.native="editFilterCondition(filter, index)" class="md-icon-button md-chip-icon-button md-dense">
                <md-icon>edit</md-icon>
              </md-button>
            </md-chip>
          </div>
        </div>
      </div>

      <!-- WBDataTable body -->
      <md-table class="datatable" :class="[height?'full-height':'', adjustableColumnWidth?'adjustable-column-width-table':'']" :style="{height: height}" :md-sort="sort.name" :md-sort-type="sort.type" @sort="onSort" >
        <!--<md-table :class="[height?'full-height':'']" :style="{height: height}" @select="onSelect" @sort="onSort">-->
        <md-table-header>
          <md-table-row>
            <md-table-head class="select-all" :style="{width: '60px'}" v-if="hasSelection">
              <input v-if="!disableMultiSelect" type="checkbox" @change="selectAll"/>
            </md-table-head>
            <md-table-head
              v-for="column in visibleColumns"
              v-if="column.visible"
              :class="[(column && column.type && column.type == 'number') ?'text-align-right':'', column.name]"
              :md-sort-by="column.name"
              :key="column.name"
              :style="{'font-size':fontSize, width: column.width}"
              :data-title="column.displayName"
            >
              <!--@click.shift.native="setSort(true, $event)"-->
              <!--@click.native="setSort(false)"-->
              {{column.displayName}}
            </md-table-head>
            <md-table-head v-if="hasControls && !disableRowControlls" md-numeric class="table-edit-header">
              Edit
            </md-table-head>
          </md-table-row>
        </md-table-header>
        <md-table-body>
          <template>
            <template v-for="(row, rowIndex) in paginatedDataext" >
              <tr
                :md-item="paginatedDataext[rowIndex]"
                :key="row.id"
                :ref="'rowItem'"
                :draggable="row.draggable"
                v-on:dragend.native="dragEnd(row, $event)"
                v-on:dragstart.native="dragStart(row, $event)"
                v-on:dragover.native="allowDrop($event)"
                v-on:drop.native="drop()"
                :md-selection="false"
                :md-auto-select="false"
                :class="['item-' + row.id, (row && row.customClassName)?row.customClassName:'', 'md-table-row']"
                :data-target="row.id"
                @click="clickOnRow($event, row.id)"
                v-on:mouseover="$emit('mouseOverRow', $event, row)"
                v-on:mouseleave="$emit('mouseLeaveRow', $event, row)"
              >
                <!-- , isSelectedRow(row)?'md-selected':'' -->
                <td v-if="hasSelection" class="md-table-cell select-column" style="width: 60px" >
                  <div class="md-table-cell-container">
                    <input type="checkbox" @change="onSelect" :data-target="row.id"/>
                  </div>
                </td>
                <custom-table-cell
                  v-for="(column, columnIndex) in columns"
                  ref="customTableCell"
                  :key="column.name"
                  :hasSelection="hasSelection"
                  :row="row"
                  :allowTooltips="allowTooltips"
                  :fontSize="fontSize"
                  :column="column"
                  :columnIndex="columnIndex"
                  :columnCellClass="columnCellClasses[column.name]"
                  :isSimpleCell="isSimpleCell[column.name]"
                  :isEditableBoolean="isEditableBoolean[column.name]"
                  :dataList0="dataList0"
                  :dataList1="dataList1"
                  :dataList2="dataList2"
                  :dataList3="dataList3"
                  :objectList="objectList"
                  :rowIndex="rowIndex"
                  :adjustableColumnWidth="adjustableColumnWidth"
                  :dataTimePlaceholder="dataTimePlaceholder"
                  :columns="visibleColumns"
                  @setRowBlur="setRowBlur"
                  @setFocus="setFocus"
                  @setRowChanged="setRowChanged"
                  @setRowSelect="setRowSelect"
                  @ondragAdjustableBorder="ondragAdjustableBorder"
                  @showSelectWindow="showSelectWindow"
                >
                  <slot v-if="column.slotName" :name="column.slotName" v-bind:row="row">Where is your slot content?</slot>
                </custom-table-cell>
                <td v-if="hasControls && !disableRowControlls" class="md-table-cell table-edit-column">
                  <div class="md-table-cell-container">
                    <md-menu md-align-trigger md-direction="bottom left" class="tree__item-dropdown">
                      <md-button @click.stop.prevent md-menu-trigger>
                        <md-icon>more_vert</md-icon>
                      </md-button>
                      <md-menu-content class="data-table-more-vert">
                        <md-menu-item
                          :class="[(control && control.customClassName) ? control.customClassName : '', (row && row.customClassName)?row.customClassName:'']"
                          v-for="(control, key) in customControls"
                          v-if="customControls && ((typeof control.hide !== 'function' && !control.hide) || (typeof control.hide === 'function' && !control.hide(row)))"
                          :key="key" @click="control.handler(row, columns)"
                        >
                          <md-icon class="save-button">{{control.icon}}</md-icon>
                          {{control.name}}
                        </md-menu-item>
                        <md-menu-item :class="(row && row.customClassName)?row.customClassName:''" class="editControlButton" v-if="!disallowEditing" @click="$emit('editEmit', row, columns, false)"><md-icon class="save-button">edit</md-icon>Edit</md-menu-item>
                        <md-menu-item :class="(row && row.customClassName)?row.customClassName:''" class="deleteControlButton" v-if="!disallowDeleting" @click="$emit('deleteEmit', row)"><md-icon class="delete-button">delete</md-icon>Delete</md-menu-item>
                      </md-menu-content>
                    </md-menu>
                  </div>
                </td>
              </tr>
              <slot name="sub-row" :row="row"></slot>
            </template>
          </template>

          <div v-if="selectToOpenObj && selectToOpenObj.show" class="select-modal" :style="{top: selectToOpenObj.top, left: selectToOpenObj.left}">
          <div v-for="item in selectToOpenObj.objectList" v-if="!(item.isHidden && typeof item.isHidden === 'function' && item.isHidden(selectToOpenObj.row))" :key="item.id" @click="selectValue(item, selectToOpenObj.row, selectToOpenObj.column)">
            {{item.name}}
          </div>
        </div>
        <div v-if="selectToOpenObj && selectToOpenObj.show" class="select-modal-backdrop"  @click="hideSelectWindow"></div>
        </md-table-body>
      </md-table>
      <md-table-pagination v-if="pagination"
                           :md-size="pagination.size"
                           :md-page="page"
                           md-label="Rows"
                           :md-total="totalSize"
                           md-separator="of"
                           :md-page-options="pagination.options?pagination.options:[pagination.size]"
                           @pagination="onPagination">
      </md-table-pagination>
    </md-table-card>
    <filter-modal
      v-if="showFilterModal"
      @closeModal="closeModal()"
      :columns="columns"
      :data="dataext"
      :filter="selectedFilter"
      :customFilterOptions="customFilterOptions"
      @processFilterChange="processFilterChange(arguments[0])">
    </filter-modal>
  </div>
</template>
<style>
  .md-select-content.md-direction-bottom-right {
    z-index: 9999;
  }
  .datatable-tooltip {
    position: absolute;
    top: 0;
    white-space: nowrap;
    left: 0;
    background: #222;
    color: #ffffff;
    border-radius: 2px;
    padding: 2px 10px;
    display: none;
  }
  .md-table-cell:hover .datatable-tooltip {
    display: block;
  }

  .search-container {
    width: 200px;
  }

  .md-menu-content.data-table-more-vert {
    z-index: 9999;
  }
  .custome-header {
    display: flex;
    justify-content: space-between;
    -ms-align-items: center;
    align-items: center;
  }

  .custome-header .tools {
    display: flex;
    align-items: center;
  }

  .custome-header .tools .md-input-container {
    padding-top: 0 !important;
  }
  .custome-header .tools > div > .md-menu{
    width: 40px;
    min-width: 40px;
    height: 40px;
    padding: 8px;
    border-radius: 50%;
    line-height: 24px;
  }

  .custome-header .title {
    display: flex;
    align-items: center;
  }

  .custome-header .title p {
    margin: 0 20px;
    padding: 0;
  }

  .datatable .md-table-header .md-table-row {
    background: #f2f2f2;
    height: 46px;
  }

  .datatable .md-select .md-select-value {
    height: auto;
    white-space: normal;
    line-height: 15px;
  }

  .datatable .md-select.md-disabled:after {
    display: none;
  }

  .datatable .md-select .md-menu {
    height: auto;
  }

  .datatable .md-select {
    height: auto;
  }

  .datatable .md-input-container.md-has-value input {
    -ms-text-overflow: ellipsis;
    text-overflow: ellipsis;
  }

  .datatable .md-select select {
    display: none;
  }

  .datatable .md-table-row .table-edit-column {
    width: 50px;
  }
  .datatable .md-table-row .table-edit-header,
  .datatable .md-table-row .table-filter-header {
    width: 65px;
  }
  .datatable .md-table-row .table-filter-header>div{
    padding: 6px 0;
  }
  .datatable .md-table-row .table-filter-header>div .md-icon {
    margin: 0 auto;
  }

  .datatable .table-edit-column.md-has-action .md-table-cell-container {
    padding: 0;
  }

  .datatable .md-table-cell .md-table-cell-container .md-button {
    width: 36px;
    min-width: 36px;
    height: 36px;
    min-height: 36px;
    padding: 0;
  }

  .datatable .md-table-cell .md-table-cell-container .md-button .md-icon {
    font-size: 16px;
  }

  .md-table div.md-table-head-text {
    white-space: normal;
    height: auto;
    line-height: 1.2;
    /*word-wrap: break-word;*/
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px 0 0;
  }
  .md-table div.md-table-head-container {
    max-height: 60px;
    height: auto;
    padding: 6px 32px 6px 24px
  }
  .md-table .md-table-head .md-icon:last-child {
    left: auto;
    right: 10px;
  }
  .md-table {
    position: relative;
    /*overflow-y: visible !important;*/

  }
  .md-checkbox .md-checkbox-container:before {
    height: 100%;
    max-height: 100%;
  }
  .select-row{
    cursor: pointer;
  }

  .wb-tooltip {
    /*height: 20px;*/
    position: absolute;
    z-index: 14;
    pointer-events: none;
    background-color: rgba(97,97,97,.87);
    border-radius: 2px;
    opacity: 0;
    transform-origin: center top;
    transition: all .01s cubic-bezier(.25,.8,.25,1);
    transition-duration: 0.01s;
    transition-delay: 0s;
    color: #fff;
    font-family: Roboto,Noto Sans,Noto,sans-serif;
    font-size: 10px;
    line-height: 1;
    text-transform: none;
    white-space: pre-line;
    word-break: break-all;
    max-height: 0;
    padding: 0;
  }
  .datatable-wrapper .tools button:hover + .wb-tooltip,
  .datatable-wrapper .tools .md-menu:hover + .wb-tooltip,
  .md-table-row .md-table-cell:hover .wb-tooltip {
    padding: 8px 8px;
    max-height: none;
    opacity: 0.8;
  }
  .md-table-row.dragging .md-table-cell .wb-tooltip {
    max-height: 0;
    opacity: 0;
    padding: 0;
    transition: all 0s cubic-bezier(.25,.8,.25,1);
    transition-duration: 0s;
    transition-delay: 0s;
  }
  .order-table .md-table .md-table-body .md-table-row .md-table-cell.md-has-action .md-table-cell-container {
    pointer-events: none;
  }
  .admin-table .md-table .md-table-body  .md-table-row .md-table-cell.md-has-action .md-table-cell-container {
    pointer-events: none;
  }
  .quick-filter {
    font-size: 12px;
  }
  .quick-filter label {
    margin: 0 10px 0 0;
  }
  .datatable .select-column .md-table-cell-container,
  .datatable .select-all .md-table-head-container>div,
  .datatable .select-all .md-table-head-container {
    padding: 0 !important;
    text-align: right;
  }
  .datatable .select-column .md-table-cell-container input,
  .datatable .select-all .md-table-head-container input {
    font-size: 1rem;
  }
  .datatable .md-select .md-select-value {
    min-height: 20px;
  }
  .md-list-item-container.md-button {
    white-space: normal;
    line-height: 1.1rem;
    text-align: right !important;
  }
  .search-container{
    width: 200px;
  }
</style>
<style scoped>

  .select-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background: rgba(0, 0, 0, .1);
    z-index: 998;
  }
  .select-modal {
    position: absolute;
    background: #4a4a4a;
    padding: 10px;
    font-size: 12px;
    z-index: 999;
  }
  .select-modal div {
    margin: 5px 0;
    cursor: pointer;
  }
  .select-modal div:hover {
    text-decoration: underline;
  }
  .adjustable-column-width-table {
    transform: translate(0);
  }
  #quickFilter {
    font-size: 16px;
  }
  .counter-title {
    margin-left:6px;
  }
  tbody {
    display: block;
    height: auto;
    overflow: auto;
    position: relative;
  }
  .full-height thead {
    position: absolute;
    z-index: 2;
    background: #fff;
    max-width: 100%;
    overflow: hidden;
  }
  .full-height tbody {
    height: calc(100% - 45px);
    top: 40px;
    position: absolute;
    padding-bottom: 60px;

  }
  thead, tbody tr {
    display:table;
    width:100%;
    table-layout:fixed;/* even columns width , fix width of table too*/
  }
  table {
    width:400px;
  }
  .data-table-container{
    height: 900px;
  }
  .table-edit-column{
    width: 70px;
  }
  .table-edit-header{
    text-align:left !important;
  }
  .md-input-container{
    margin: 0;
    padding-top: 0;
    min-height: 0;
  }
  .md-button.md-fab .md-icon, .md-button.md-icon-button .md-icon{
    position : inherit;
  }
  .select-container{
    background: #f2f2f2;
    position: absolute;
    right: 20px;
    top: 160px;
    padding: 10px 0;
    z-index: 99;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);
  }
  .select-container>div{
    overflow: auto;
    max-height: 25vh;
  }
  .select-container>div>div{
    padding-left: 10px;
  }
  .select-container>div>div:hover{
    background: #e1e1e1;
    cursor: pointer;
  }
  .select-container-select-all, .select-container-unselect-all {
    padding: 3px 0 3px 27px;
  }
  .md-theme-default.md-table-card {
    position: initial;
  }
  .md-theme-default.md-table-card .md-toolbar {
    z-index: 3;
  }
  .md-table .md-table-cell .md-table-cell-container>div>div{
    word-wrap: break-word;
    width: 100%;
    padding-right: 4px;
  }

  .filter-container {
    margin-bottom: 4px;
    display: block;
    padding-right: 4px;
    /* width: 100%; */
    /*justify-content: space-around;*/
  }
  .filter-container input {
    width: 100%;
    /*padding: 0 4px;*/
  }
  .filter-container div {
    /*padding: 0 4px;*/
  }
  .md-chip-filter{
    margin: 2px;
  }
  .md-chip-icon-button{
    height: 20px !important;
    width: 20px !important;
    min-width: 20px !important;
    line-height: 20px !important;
    min-height : 20px !important;
    margin: 0 !important;
    padding: 0 !important;
    margin-top: -3px !important;
  }
  .md-chip-icon-button .md-icon{
    font-size: 16px !important;
  }
  .filter-select-container {
    position: relative;
  }
  .filter-select-container > div {
    position: absolute;
    max-height: 200px;
    width: 100px;
    overflow: auto;
    background: #fff;
    font-size: 10px;
    box-shadow: 1px 1px 5px #888888;
  }
  .filter-select-container > div div {
    padding: 2px;
  }
  .filter-select-container > div div:hover {
    background: #eee;
    cursor: pointer;
  }
  .search-container{
    width: 200px;
  }
</style>
<script>
  import Datepicker from 'vue-datepicker/vue-datepicker-es6.vue';
  import moment from 'moment';
  import filterModal from './filterModal.vue';
  import datePickerWrapper from './datePickerWrapper.vue';
  import customTableCell from './customTableCell.vue';
  import Vue from 'vue';

  export default {
    name: 'dataTable',
    components: {
      filterModal,
      datePickerWrapper,
      Datepicker,
      customTableCell,
    },
    props: [
      'adjustableColumnWidth',
      'isTitleHtml',
      'htmlTitle',
      'dateTimeFormat',
      'dataTimePlaceholder',
      'customHeaderTools',
      'columns',
      'dataext',
      'dataLength',
      'hasControls',
      'hasSelection',
      'hasAutoSelection',
      'tableName',
      'dataList0',
      'dataList1',
      'dataList2',
      'dataList3',
      'objectList',
      'listOfOptionsForSwitch',
      'height',
      'fontSize',
      'saveColumnSelection',
      'saveFilters',
      'saveSort',
      'indentHeight',
      'allowCreation',
      'disallowEditing',
      'disallowDeleting',
      'quickFilter',
      'searchKey',
      'searchKeys',
      'hasFilter',
      'disableMultiSelect',
      'disableSearch',
      'disableRowControlls',
      'countTitle',
      'customControls',
      'listForAutocomplete',
      'formatForDateWithTime',
      'allowTooltips',
      'customSortFunction',
      'pagination',
      'customFilterOptions',
      'showVisibleFilteredDataextCounter',
      'selectOrUnselectAllColumnsOptionVisible',
      'minItemSize'
    ],
    data () {
      return {
        selectToOpenObj: {},
        dragColumnBorderTimer: null,
        applyQuickFilter: (this.quickFilter && this.quickFilter.value)?this.quickFilter.value:false,
        selectedData: {},
        selectedDataLength: 0,
        localDataLength: this.dataLength || 100000,
        sort: {},
        showColumn: null,
        showColumnSettings: false,
        visibleColumns: [],
        selectedIndexesData: [],
        filterValues: {},
        filterBy: [],
        filterNumber: {},
        showFilterNumber: {},
        savedColumns : [],
        initialSortExecuted: false,
        showFilterModal : false,
        selectedFilter: {filterValue: null, filterCondition: null, },
        shadowList : [],
        previousSelected : 0,
        // for prevent default and stop propagation thats
        // not works well with click and click.shift
        wasMultiSorted: false,
        isMounted: false,
        searchTerm: '',
        dateArrayForDatepicker: {},
        option: {
          type: 'min',
          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          format: this.formatForDateWithTime,
          placeholder: 'when?',
        },
        page: 1,
        totalSize: null,
      };
    },
    created() {
      this.visibleColumns = this.columns;
    },
    mounted() {
      // Finding tbody tag in all datatables on the page
      // And setting computed height
      const tbodyArray = document.querySelectorAll('.datatable tbody');
      for (let i = 0; i < tbodyArray.length; i++) {
        tbodyArray[i].style.maxHeight = `calc(100vh - ${this.indentHeight}px)`;
      }
      this.loadLocalStorage();
    },
    updated() {
    },
    watch: {
      columns: function (val) {
        this.loadLocalStorage();
        if (this.saveColumnSelection) {
          let oldColumns = this.columns;
          this.visibleColumns = val.map((column) => {

            let current = oldColumns.find(oldColumn => oldColumn.name === column.name && column.visible);
            if (current) {
              column.visible = current.visible;
            }
            return column;
          });
          this.$forceUpdate();
        } else {
          this.visibleColumns = val;
        }
      },
      dataext: function (val, oldVal) {
        let self = this;
        let forceSort = val.length != oldVal.length && val.length > 0 && oldVal.length > 0;
        if (this.filterBy.length > 0) {
          //if the length is bigger than 0, go through the rows and filter them based on the filter functions - this will be expensive based on the number of filters
          this.filterData(function() {
            if(forceSort) {
              self.executeSavedSortFunction(forceSort);
            }
          });
        } else {
          if(forceSort) {
            self.executeSavedSortFunction(forceSort);
          }
        }
      },
      visibleFilteredDataext: function(val) {
        this.$emit('visibleDataChanged', val);
      }
      // dateArrayForDatepicker(val, oldVal) {
      //   console.log(val);
      //   deep: true
      // }
    },
    methods: {
      selectValue(value, row, column) {
        let curFilteredRowIndex = this.paginatedDataext.findIndex(i => i.id == row.id);
        let curRowIndex = this.dataext.findIndex(i => i.id == row.id);
        row[column.name] = value.id;
        this.paginatedDataext[curFilteredRowIndex][column.name] = value.id;
        this.hideSelectWindow();
        this.$nextTick(() => {
          this.dataext[curRowIndex] = Object.assign(this.paginatedDataext[curFilteredRowIndex], row);
          const element = this.$el.querySelector(`.md-table-row.item-${row.id} .${column.name} .md-select-value`);
          if (element) {
            element.innerText = value.name;
          }
          this.$emit('changeEmit', this.dataext[curRowIndex], column);
          this.$emit('blurEmit', this.dataext[curRowIndex], column);
          this.$emit('focusEmit', this.dataext[curRowIndex], column);
        });
      },
      hideSelectWindow() {
        this.selectToOpenObj = {
          show: false,
        };
      },
      showSelectWindow(e, row, column, objectList, disabled) {
        if (disabled) return;
        let tdEl = e.path.find(i => i.className.indexOf(' md-table-cell') !== -1);
        console.log(e.path)
        this.selectToOpenObj = {
          show: true,
          row,
          column,
          objectList,
          top: tdEl.offsetTop + 'px',
          left: tdEl.offsetLeft + 'px',
        };
      },
      ondragAdjustableBorder(row, column, firstPosition, lastPosition, column1Width, column2Width) {
        // clearTimeout(this.dragColumnBorderTimer);
        // this.dragColumnBorderTimer = setTimeout(() => {

          // let tempColumns = JSON.parse(JSON.stringify(this.columns));
          let tempIndex = this.visibleColumns.findIndex(i => i.name === column.name && i.displayName === column.displayName);
  
          const diff = parseFloat(firstPosition) - parseFloat(lastPosition);

          this.visibleColumns[tempIndex].width = parseFloat(column1Width) + diff + 'px';
          this.visibleColumns[tempIndex - 1].width = parseFloat(column2Width) - diff + 'px';
          this.$forceUpdate();
          const tempLines = document.querySelectorAll(`.adjustable-column-width-table .temp-line`);
          if (tempLines.length > 0) {
            tempLines.forEach(i => {
              i.remove();
            })
          }
          this.$emit('ondragAdjustableBorder', this.visibleColumns);

        // }, 15);
      },
      quickFilterChange(val) {
        this.applyQuickFilter = this.quickFilter.value;
        this.$forceUpdate();
      },
      filterList(list, query) {
        let result = list.filter(item => item.name.indexOf(query) === -1 ? false : true);
        console.log('RESULT');
        console.log(result, query);
        return result;
      },
      onTab() {
        console.log('last');
      },
      onTabA() {
        console.log('not last');
      },
      filterData:  function (cb) {
        let self = this;
        this.$emit('onFiltered', this.visibleFilteredDataext);
        if (cb) cb();
        this.closeModal();
      },
      selectRowAlternative : function(row){
        let index = this.shadowList.findIndex(function(shadowItem){ return shadowItem.id == row.id });
        if(index == -1)
          this.shadowList.push(row);
        else
          this.shadowList.splice(index, 1);
        this.$emit('selectEmit', row);
      },
      removeFromShadowList : function(orderId){
        let index = this.shadowList.findIndex(function(shadowItem){ return shadowItem.id == orderId });
        if(index > -1)
          this.shadowList.splice(index, 1);
      },
      clearShadowList : function(){
        this.shadowList = [];
      },
      isSelectedRow: function (row) {
        let rez = this.selectedIndexesData.indexOf(row.id);
        return rez > -1;
      },
      selectAll: function (e) {
        const self = this;
        let value = e.target.checked;

        let elements = this.$el.querySelectorAll(`.select-column input`).forEach(e => e.checked = value);
        if (value) {
          this.selectedIndexesData = this.visibleFilteredDataext.map(i => i.id.toString());
          this.selectedData = this.visibleFilteredDataext.filter(item => {
            return self.selectedIndexesData.indexOf(item.id.toString()) !== -1;
          })
          this.$emit('onSelect', this.selectedData);
        } else {
          this.selectedIndexesData = [];
          this.$emit('onSelect', []);
        }
      },
      onSelect(e) {
        const self = this;
        let value = e.target.checked;
        let selectedId = e.target.dataset.target.toString();

        if (value && !this.disableMultiSelect) {
          this.selectedIndexesData.push(selectedId);
        } else if (value && this.disableMultiSelect) {
          this.selectedIndexesData.forEach(rowId => {
            if (this.$el.querySelector(`.item-${rowId} input`)) {
              this.$el.querySelector(`.item-${rowId} input`).checked = false;
            }
          });
          this.selectedIndexesData = [selectedId];
        } else {
          let index = this.selectedIndexesData.indexOf(selectedId);
          if (index !== -1) {
            this.selectedIndexesData.splice(index, 1);
          }
        }
        this.selectedData = this.visibleFilteredDataext.filter(item => {
          return self.selectedIndexesData.indexOf(item.id.toString()) !== -1;
        })
        this.$emit('onSelect', this.selectedData);
      },
      onSort(sort) {
        this.sort = sort;
        this.$emit('sort_column', this.dataext, sort);
      },
      setSort: function(isShift, e) {
        let oldSettingsVal = JSON.parse(this.$localStorage.get(this.tableName));
        if (this.wasMultiSorted) {
          this.wasMultiSorted = false;
          return false;
        }
        if (!isShift) {
          oldSettingsVal.sort = {};
        }
        oldSettingsVal.sort[this.sort.name] = this.sort.type;
        if(this.saveSort) {
          this.saveSortFunction(JSON.stringify(oldSettingsVal));
        }
        const newSort = oldSettingsVal.sort;
        this.$emit('sort_column', this.dataext, newSort);
        if (e) {
          this.wasMultiSorted = true;
        }
      },
      getObjectList: function (list) {
        return this[list];
      },
      addObject: function () {
        this.$emit('add_row', this.selectedData);
      },
      deleteRows: function() {
        this.$emit('delete_rows', _.sortBy(this.shadowList, 'id'));
      },
      saveRow: function(row) {
        this.$emit('save_row', row);
        this.$nextTick(function() {
          row.hasChanges = undefined;
          // this.onSelect(this.selectedData);
        });
      },
      setRowBlur(row, column) {
        this.$nextTick(() => {
          this.$emit('blurEmit', row, column);
        })
      },
      setFocus(row, column) {
        this.$nextTick(() => {
          this.$emit('focusEmit', row, column);
        })
      },
      setRowChanged(row, column, isDatepicker) {
        this.$nextTick(() => {
          row.hasChanges = true;
          this.$emit('changeEmit', row, column);
          if(isDatepicker) {
            this.$forceUpdate();
          }
          // this.onSelect(this.selectedData);
        });
      },
      setRowSelect(row, column) {
        this.$nextTick(() => {
          row.hasChanges = true;
          this.$emit('onSelect', row, column, 'select');
        });
      },
      onPagination : function (payload) {
        if (this.pagination.size !== payload.size)
          this.pagination.size = payload.size;
        this.page = payload.page;
        this.$emit('paginate', payload);
      },
      dragEnd: function (row, e) {
        let oldClassName = e.target.className;
        e.target.className = oldClassName.replace(/dragging/g, '');
        this.$emit('drag-end', row);
      },
      dragStart: function (row, e) {
        let oldClassName = e.target.className;
        e.target.className = `${oldClassName} dragging`;
        this.$emit('drag-start', row);
      },
      allowDrop: function (event) {
        event.preventDefault();
      },
      drop: function () {
        this.$emit('drop');
      },
      toggleColumnSettings: function (column) {
        if (column && column.type === 'click') {
          this.showColumnSettings = false;
          document.removeEventListener('click', this.toggleColumnSettings);
        }
        //BB don't close the column selection when selecting / deselecting columns
        if(!column) {
          this.showColumnSettings = !this.showColumnSettings;
          if (this.showColumnSettings)
            setTimeout(() => document.addEventListener('click', this.toggleColumnSettings), 0);
          else
            document.removeEventListener('click', this.toggleColumnSettings);
        }
        if (!column) return;

        let newColumns = this.visibleColumns;

        if (column === 'show all') {
          newColumns = this.visibleColumns.map((curentColumn) => {
            if (!curentColumn.fake) {
              curentColumn.visible = true;
            }
            return curentColumn;
          });
        } else if (column === 'hide all') {
          newColumns = this.visibleColumns.map((curentColumn) => {
            if (!curentColumn.fake) {
              curentColumn.visible = false;
            }
            return curentColumn;
          });
        } else {
          let columnName = column[0];
          let columnVisible = column[1];
          newColumns = this.visibleColumns.map((curentColumn) => {
            if (curentColumn.name === columnName) {
              curentColumn.visible = !columnVisible;
            }
            return curentColumn;
          });
        }

        const tempLines = document.querySelectorAll(`.adjustable-column-width-table .temp-line`);
        if (tempLines.length > 0) {
          tempLines.forEach(i => {
            i.remove();
          })
        }

        // handler for saving the columns
        if(this.saveColumnSelection){
          let oldSettingsVal = JSON.parse(this.$localStorage.get(this.tableName));

          let newSettings = {};
          if (oldSettingsVal) {
            newSettings = Object.assign({ ...oldSettingsVal }, { columns: newColumns });
          } else {
            newSettings = { columns: newColumns };
          }
          this.saveColumnSelectionFunction(JSON.stringify(newSettings))
        }
      },
      addFilterCondition: function(){
        this.selectedFilter = {isNew: true};
        this.showFilterModal = true;
      },
      editFilterCondition: function(filter, index) {
        this.selectedFilter = Object.assign({}, filter, {isNew: false, index});
        this.showFilterModal = true;
      },
      processFilterChange: function(filter) {
        if (filter.isNew) {
          this.filterBy.push(filter);
        } else {
          let filterParsed = JSON.parse(JSON.stringify(this.filterBy));
          this.filterBy = filterParsed.map((item, i) => {
            if(filter.index === i)
              item = filter;
            return item;
          });
        }
        if (this.saveFilters) {
          let oldSettingsVal = JSON.parse(this.$localStorage.get(this.tableName));
          let newSettings = Object.assign({...oldSettingsVal}, {filterBy: this.filterBy});
          this.saveFiltersFunction(JSON.stringify(newSettings));
        }
        this.filterData();
        this.closeModal();
      },
      deleteFilterCondition: function(filter){
        let index = this.filterBy.findIndex(function(element){ return element === filter})
        if(index > -1)
          this.filterBy.splice(index, 1);
        this.filterData();
        if(this.saveFilters){
          let oldSettingsVal = JSON.parse(this.$localStorage.get(this.tableName));
          let newSettings = Object.assign({...oldSettingsVal}, {filterBy: this.filterBy});
          this.saveFiltersFunction(JSON.stringify(newSettings));
        }
      },
      closeModal: function() {
        this.selectedFilter = {};
        this.showFilterModal = false;
      },
      saveColumnSelectionFunction : function(tableAsJsonString){
        this.$localStorage.set(this.tableName, tableAsJsonString);
      },
      saveSortFunction : function(tableAsJsonString){
        this.$localStorage.set(this.tableName, tableAsJsonString);
      },
      saveFiltersFunction: function(tableAsJsonString){
        this.$localStorage.set(this.tableName, tableAsJsonString);
      },
      executeSavedSortFunction: function(forceSort){
        if((this.dataext.length > 0 && !this.initialSortExecuted) || forceSort) {
          // this.setSort(true);
          this.onSort(this.sort);
          this.initialSortExecuted = true;
        }
      },
      loadLocalStorage: function(){
        if(this.saveColumnSelection){
          
          if( JSON.parse(this.$localStorage.get(this.tableName)) && JSON.parse(this.$localStorage.get(this.tableName)).columns){
            this.savedColumns = JSON.parse(this.$localStorage.get(this.tableName)).columns;
            let self = this;
            this.columns.forEach(function(oldColumn) {
              if(self.savedColumns.findIndex(function(savedColumn){ return oldColumn.name == savedColumn.name && savedColumn.visible}) > -1){
                oldColumn.visible = true;
              } else {
                oldColumn.visible = false;
              }
              self.$forceUpdate();
            })
          }
        }

        if(this.saveFilters){
          if( JSON.parse(this.$localStorage.get(this.tableName)) && JSON.parse(this.$localStorage.get(this.tableName)).filterBy){
            this.filterBy = JSON.parse(this.$localStorage.get(this.tableName)).filterBy
          }
        }
      },
      clickOnRow: function(e, selectedId) {
        if (this.hasAutoSelection && e.target.localName !== 'input' && !e.target.closest('.datepicker-overlay')) {
          this.$el.querySelector(`.item-${selectedId} input`).click();
        }
      },
    },
    computed: {
      columnCellClasses: function() {
        let result = {};
        this.visibleColumns.map(column => {
          let className = [column.name];
          if (column && column.type && column.type == 'number')
            className.push('text-align-right');
          result[column.name] = className;
        })
        return result;
      },
      isSimpleCell: function() {
        let result = {};
        this.visibleColumns.map(column => {
          result[column.name] = column.visible &&
            column.type !== 'boolean' && column.type !== 'autocomplete' &&
            column.type !== 'dateWithTime' && column.type !== 'dateFromTo' &&
            column.type !== 'time' &&
            !column.cellTemplate && !column.isObjectSelection && !column.isButtonColumn &&
            !column.isObjectMultiSelection;
        })
        return result;
      },
      isEditableBoolean: function() {
        let result = {};
        this.visibleColumns.map(column => {
          result[column.name] = column && (typeof column.isEditable !== 'function') && column.isEditable;
        })
        return result;
      },
      visibleFilteredDataext: function () {
        let visibleValues = JSON.parse(JSON.stringify(this.dataext));

        // sorting
        if (this.visibleColumns) {
          let sortType = this.visibleColumns.find(item => {
            return item.name === this.sort.name;
          });

          if (sortType) {
            if (sortType.type === 'number' && !this.customSortFunction) {
              visibleValues.sort((a, b) => this.sort.type == 'desc' ? +b[this.sort.name] - +a[this.sort.name] : +a[this.sort.name] - +b[this.sort.name]);
            } else if (sortType.type === 'dateTime' && !this.customSortFunction) {
              visibleValues.sort((a, b) => {
                if (!a[this.sort.name] || moment(a[this.sort.name], this.dateTimeFormat).format().toLowerCase() === 'invalid date')
                  return 1;
                if (!b[this.sort.name] || moment(b[this.sort.name], this.dateTimeFormat).format().toLowerCase() === 'invalid date')
                  return -1;
                if (a[this.sort.name] == b[this.sort.name])
                  return 0;
                if (this.sort.type == 'desc')
                  return moment(moment(a[this.sort.name], this.dateTimeFormat).format()).isAfter(moment(b[this.sort.name], this.dateTimeFormat).format()) ? 1 : -1;
                return moment(moment(a[this.sort.name], this.dateTimeFormat).format()).isBefore(moment(b[this.sort.name], this.dateTimeFormat).format()) ? 1 : -1;
              });
            } else if (this.customSortFunction) {
              visibleValues.sort((a, b) => {
                return this.customSortFunction(a, b, this.sort);
              });
            } else {
              visibleValues.sort((a, b) => {
                if (this.sort.type == 'desc')
                  return a[this.sort.name] < b[this.sort.name]?1:-1;
                return a[this.sort.name] > b[this.sort.name]?1:-1;
              });
            }
          }
        }

        // search by searchTerm
        let searchKey = (this.searchKey && visibleValues[0]) ? this.searchKey : 'name';
        if (this.searchTerm && this.searchTerm != '' && searchKey && visibleValues[0] && !this.searchKeys) {
          const columnToSearchBy = this.visibleColumns.find(c => c.name === this.searchKey);
          if (columnToSearchBy && columnToSearchBy.isObjectSelection && columnToSearchBy.objectList && columnToSearchBy.objectList != 'objectList' && this[columnToSearchBy.objectList]) {
            const matchedIds = this[columnToSearchBy.objectList].filter(i => i.name.toLowerCase().match(this.searchTerm.toLowerCase())).map(i => ('' + i.id).toLowerCase());
            visibleValues = visibleValues.filter((item) => {
              if(item[searchKey]) {
                const searchValue = '' + item[searchKey];
                let rez = matchedIds.indexOf(searchValue.toLowerCase());
                return rez > -1;
              }
            });
          } else {
            visibleValues = visibleValues.filter((item) => {
              if(item[searchKey] && (!columnToSearchBy || (columnToSearchBy && !columnToSearchBy.format))) {
                const searchValue = '' + item[searchKey];
                let rez = searchValue.toLowerCase().match(this.searchTerm.toLowerCase());
                return rez;
              } else if (item[searchKey] && columnToSearchBy && columnToSearchBy.format) {
                const searchValue = '' + moment(item[searchKey]).format(columnToSearchBy.format);
                let rez = searchValue.toLowerCase().match(this.searchTerm.toLowerCase());
                return rez;
              }
            });
          }
        } else if (this.searchTerm && this.searchTerm != '' && visibleValues[0] && this.searchKeys) {
          const columnsToSearchBy = this.visibleColumns.filter(c => this.searchKeys.indexOf(c.name) !== -1);
          visibleValues = visibleValues.filter((item) => {
            let rez = false;
            columnsToSearchBy.forEach(columnToSearchBy => {
              if (columnToSearchBy &&
                  columnToSearchBy.isObjectSelection &&
                  columnToSearchBy.objectList &&
                  columnToSearchBy.objectList != 'objectList' &&
                  this[columnToSearchBy.objectList] &&
                  item[columnToSearchBy.name]
              ) {
                const matchedIds = this[columnToSearchBy.objectList].filter(i => i.name.toLowerCase().match(this.searchTerm.toLowerCase())).map(i => ('' + i.id).toLowerCase());
                const searchValue = '' + item[columnToSearchBy.name];
                if (matchedIds.indexOf(searchValue.toLowerCase()) > -1) {
                  rez = true;
                }
              } else if (!rez && item[columnToSearchBy.name] && (!columnToSearchBy || (columnToSearchBy && !columnToSearchBy.format))) {
                const searchValue = '' + item[columnToSearchBy.name];
                if (!!searchValue.toLowerCase().match(this.searchTerm.toLowerCase())) {
                  rez = true;
                }
              } else if (!rez && item[columnToSearchBy.name] && columnToSearchBy && columnToSearchBy.format) {
                const searchValue = '' + moment(item[columnToSearchBy.name]).format(columnToSearchBy.format);
                if (!!searchValue.toLowerCase().match(this.searchTerm.toLowerCase())) {
                  rez = true;
                }
              }
            });
            return rez;
          });
        }

        let filterValue = '';
        if (this.quickFilter && this.quickFilter.value && this.applyQuickFilter)
          filterValue = (typeof this.quickFilter.value == 'string')?this.quickFilter.value:(!!this.quickFilter.value).toString();
        if (this.applyQuickFilter && this.quickFilter && this.quickFilter.title && this.quickFilter.property  && filterValue === 'true') {
          visibleValues = visibleValues.filter(item => {
            let itemValue = (typeof item[this.quickFilter.property] == 'string')?item[this.quickFilter.property]:(!!item[this.quickFilter.property]).toString();
            if (this.quickFilter.reverse)
              return  itemValue !== filterValue;
            else
              return itemValue === filterValue;
          })
        }

        if (this.quickFilter && this.applyQuickFilter && this.quickFilter.filterValue &&
          this.quickFilter.conditions && this.quickFilter.property) {
          filterValue = this.quickFilter.filterValue;
          visibleValues = visibleValues.filter(item => {
            let itemValue = (item[this.quickFilter.property])?item[this.quickFilter.property]:(!!item[this.quickFilter.property]).toString();
            let result = true;
            // console.log(this.quickFilter.conditions, +itemValue, +filterValue, +itemValue < +filterValue)
            switch (this.quickFilter.conditions) {
              case '>':
                result = +itemValue > +filterValue;
                break;
              case '>=':
                result = +itemValue >= +filterValue;
                break;
              case '<':
                result = +itemValue < +filterValue;
                break;
              case '<=':
                result = +itemValue <= +filterValue;
                break;
              case '==':
                result = itemValue == filterValue;
                break;
              case '!=':
                result = itemValue != filterValue;
                break;
              case '===':
                result = itemValue === filterValue;
                break;
              case '!==':
                result = itemValue !== filterValue;
                break;
            }
            return result;
          })
        }

        // filtering data
        let filteredData = [];
        for(let i = 0; i < visibleValues.length; i++) {
          let element = visibleValues[i];
          let rowOk = true;
          for(let j = 0; j < this.filterBy.length; j++) {
              let filter = this.filterBy[j];
              const column = this.columns.find(c => c.name === filter.column);
              let value = element[filter.column]+'';
              if (column && column.filterByValue) {
                value = ''+column.filterByValue(element);
              }
              //todo: implement correct conditions
              if(filter.columnType !== 'number' && !filter.filterObjectSelection && value && filter.filterValue && value != '') {
                if(filter.filterCondition == '=') {
                  if (value.toLowerCase() !== filter.filterValue.toLowerCase())
                    rowOk = false;
                }
                else if(filter.filterCondition == 'Contains'){
                  if(value.toLowerCase().indexOf(filter.filterValue.toLowerCase()) === -1){
                      rowOk = false;
                  }
                }
                else if(filter.filterCondition == 'Starts with' && !value.toLowerCase().startsWith(filter.filterValue.toLowerCase())){
                  rowOk = false;
                }
                else if(filter.filterCondition == 'Ends with' && !value.toLowerCase().endsWith(filter.filterValue.toLowerCase())){
                  rowOk = false;
                }
              } else if (!filter.filterObjectSelection && value && filter.filterValue && value != '') {
                if(filter.filterCondition == '-' && value != filter.filterValue){
                    rowOk = false;
                }
                else if(filter.filterCondition == '>' && value <= filter.filterValue){
                    rowOk = false;
                }
                else if(filter.filterCondition == '>=' && value < filter.filterValue){
                  rowOk = false;
                }
                else if(filter.filterCondition == '<' && value >= filter.filterValue){
                  rowOk = false;
                }
                else if(filter.filterCondition == '<=' && value > filter.filterValue){
                  rowOk = false;
                }
                else if(filter.filterCondition == '!=' && value == filter.filterValue){
                  rowOk = false;
                }
              } else if((value || value + '' === 'false') && filter.filterValues && filter.filterValues != '' && filter.filterValues.indexOf(value + '') === -1) {
                rowOk = false;
              } else if (!value && filter.filterValue && filter.columnType !== "boolean") {
                rowOk = false;
              }  else if ((!value || (value && value == '')) && filter.columnType !== "boolean"){
                rowOk = false;
              }
          };
          if (rowOk)
            filteredData.push(element);
        };
        visibleValues = filteredData;

        this.totalSize = visibleValues.length;

        return visibleValues;
      },
      paginatedDataext() {
        let visibleValues = this.visibleFilteredDataext;
        if (this.pagination && this.pagination.size && Math.ceil(this.totalSize / this.pagination.size) < this.page) {
          this.page = 1;
        }

        if (this.pagination && this.pagination.size) {
          let tempData = JSON.parse(JSON.stringify(visibleValues));
          visibleValues = tempData.splice((this.page - 1) * this.pagination.size,  this.pagination.size);
        }
        return visibleValues;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// dataTable.vue?c223055a